import { render } from "./Index.vue?vue&type=template&id=25df5126&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=25df5126&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25df5126"],['__file',"src/assets/js/pages/Intercom/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25df5126"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25df5126', __exports__)) {
    api.reload('25df5126', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=25df5126&scoped=true", () => {
    api.rerender('25df5126', render)
  })

}


export default __exports__